import { userService } from '../services';

const userDetails = function(){
    try{
        return JSON.parse(localStorage.getItem('userDetails'));
    }
    catch(e){
        return {}
    }}();
const state = {
    userDetails: userDetails,
    menu:[],
    sezoneBranje:[],
    sezonePisanje:[],
    sheme:[]
};

const actions = {
    getLoggedIn({ commit }) {
        commit('getLoggedIn');

        userService.getLoggedIn()
            .then(
                user => commit('getLoggedInSuccess', user),
                error => commit('getLoggedInFailure', error)
            ).then(()=>{
                console.log("prišel do podatkov o sezoni!!!");
                userService.getSezone().then(
                    sezone=>{
                       console.log(sezone);
                        commit('setSezone',sezone);
                    }
                )
                 console.log("prišel do podatkov o shemah!!!");
                userService.getSheme().then(
                    sheme=>{
                       console.log(sheme);
                        commit('setSheme',sheme);
                    }
                )
            }
            );
    },
    clearLoggedIn({ commit }) {
        commit('clearLoggedIn');
        
    },
    getMenu({commit })
    {
        commit('getMenu');

        userService.getMenu()
            .then(

                menu => commit('getMenu', menu ),
                error => commit('getLoggedInFailure', error)
            );
    }
};

const mutations = {
    getLoggedIn(state) {
        state.userDetails = { loading: true };
    },
    getMenu(state,menu) {

     
        state.menu = menu;
    },
    setSezone(state,sezone) {
        state.sezonePisanje = sezone;
        state.sezoneBranje = sezone;
    },
     setSheme(state,sheme) {
        state.sheme = sheme;
    },
    clearLoggedIn(state) {
        console.log("spucam!!!");
        state.userDetails = {};
    },
    getLoggedInSuccess(state, user) {
        state.userDetails = user;
        console.log(state.userDetails);
        if(state.menu)
        state.menu=state.menu.filter(i=>state.userDetails.pravice.includes(i.pravice))
    },
    getLoggedInFailure(state, error) {
        console.log(error);
        state.userDetails = { error };
    },
   
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};
